import { commentsData } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-chat-smile-2-line mr-1"></i>读者热评
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            网友热评
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            来看看吃瓜群众们怎么说 —— 真实评论，热乎反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 border border-background-200/60 rounded-xl p-5 md:p-6 hover:border-background-300/60 transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-sm text-foreground-900 whitespace-nowrap">
                        {comment.name}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                    </div>
                    <div className="flex items-center gap-1 text-foreground-400 shrink-0">
                      <i className="ri-thumb-up-line text-xs"></i>
                      <span className="text-xs">{comment.likes}</span>
                    </div>
                  </div>
                  <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                    {comment.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}